module.exports = __webpack_public_path__ + "static/media/Leader Scoreboard BLUE CROWN.e75e0390.svg";